import { render, staticRenderFns } from "./discussions-controls.vue?vue&type=template&id=3f82eb78&"
import script from "./discussions-controls.vue?vue&type=script&lang=js&"
export * from "./discussions-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports